import React from 'react';
import { connect } from 'react-redux';
import { compose, withState, withHandlers, branch, renderComponent } from 'recompose';
import PropTypes from 'prop-types';

import SearchInput from 'react-search-input';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import { filterTeamMembers } from '../redux/reducers/teamMembersFull';
import { toggleAddUserPopup, toggleDeleteUserPopup } from '../redux/reducers/view';
import AddCodeButton from './AddCodeButton';
import Spinner from './Spinner';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import SearchBar from 'material-ui-search-bar'

import { commonStyles, COLORS } from '../styles/styles';

const Toolbar = ({
  classes,
  login,
  handleSearch,
  userProgramsFull,
  toggleAddUserPopup,
  handleOpenDeleteUserPopup,
}) => {
  const module =
    userProgramsFull.selectedContentId &&
    userProgramsFull.programs.programs
      .find(program => program.programId === userProgramsFull.selectedProgramId)
      .modules.find(module => module.moduleId === userProgramsFull.selectedModuleId);
  const thinkToolName =
    module &&
    module.content.find(content => content.contentId === userProgramsFull.selectedContentId) &&
    module.content.find(content => content.contentId === userProgramsFull.selectedContentId).name;
  return (
    <div className={classes.toolbar}>
      <div className={classes.firstColumn}>
        {login.user.isTeamLeader && (
          
          <SearchBar
          onChange={value => handleSearch(value)}
          onRequestSearch={() => console.log('onRequestSearch')}
          style={{
            margin: 10,
            maxWidth: 400
          }}
        />
        )}
        {/* {!login.user.isTeamLeader && <AddCodeButton />} */}
      </div>
      {login.user.isTeamLeader && (
        <div className={classes.secondColumn}>
          <Button
          thirdcolumn       variant="contained"
            className={`${classes.defaultButton} ${classes.toolBarButton}`}
            onClick={() => toggleAddUserPopup(true)}
          >
            ADD NEW USER
          </Button>
        </div>
      )}
      {/* {thinkToolName && <Typography className={classes.thirdColumn}>{thinkToolName}</Typography>}
      {!thinkToolName && <Typography className={classes.thirdColumn}>&nbsp;</Typography>} */}
      {login.user.isTeamLeader && (
        <div className={classes.fourthColumn}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleOpenDeleteUserPopup}
            className={`${classes.toolBarButton} ${classes.toolBarButtonRed}`}
          >
            DELETE USER
          </Button>
        </div>
      )}
    </div>
  );
};

const styles = () => ({
  ...commonStyles,
  search: {
    background: '#212121',
    width: '100%',
    height: 36,
    minWidth: 190,
  },
  bootstrapRoot: {
    padding: 0,
  },
  bootstrapInput: {
    borderRadius: 2,
    backgroundColor: '#FFF',
    fontSize: 12,
    color: COLORS.cornerstoneRed,
    margin: 1,
    padding: '0 12px 0 40px',
    boxShadow: '0 1px 0 0.1rem #d6d5d8',
  },
  icon: {
    position: 'absolute',
    left: 0,
    top: 0,
    color: COLORS.grey,
  },
  firstColumn: {
    flex: 1,
    justifyContent: 'end',
    display: 'flex',
    marginRight: 80
  },
  secondColumn: {
    padding: '0 20px',
  },
  thirdcolumn: {
    display: 'flex',
    flex: 5,
    alignItems: 'center',
    fontWeight: 'bold',
    justifyContent: 'center',
    color: COLORS.lightGrey,
    fontFamily: 'Gotham-Black'
  },
  fourthColumn: {
    padding: '0 20px',
  },
  textField: {
    marginLeft: 1,
    marginRight: 1,
  },
  toolbar: {
    background: '#faf9f7',
    display: 'flex',
    flexDirection: 'row',
  },
  toolBarButton: {
    padding: '0 15px',
    fontSize: 12,
    minHeight: 32,
    marginTop: 2,
  },
  toolBarButtonRed: {
    boxShadow: 'none',
    borderRadius: 0,
    backgroundColor: COLORS.lightGrey,
  },
});

const mapStateToProps = state => ({
  login: state.loginReducer,
  view: state.viewReducer,
  userProgramsFull: state.userProgramsFullReducer,
  teamMembersFullReducer: state.teamMembersFullReducer,
});

const mapDispatchToProps = dispatch => ({
  filterTeamMembers: teamMembers => dispatch(filterTeamMembers(teamMembers)),
  toggleAddUserPopup: value => dispatch(toggleAddUserPopup(value)),
  toggleDeleteUserPopup: value => dispatch(toggleDeleteUserPopup(value)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('initialSelectionUser', 'handleInitialSelectionUser', false),
  withState('searchTerm', 'searchUpdated', ''),
  withHandlers({
    handleSearch: props => value => {
      props.filterTeamMembers(value);
      props.searchUpdated(value);
    },
    handleOpenDeleteUserPopup: props => e => {
      e.preventDefault();
      if (props.teamMembersFullReducer.users) {
        props.toggleDeleteUserPopup(true);
      }
    },
  }),
  branch(props => props.login.user === null, renderComponent(Spinner)),
  withStyles(styles),
)(Toolbar);

Toolbar.propTypes = {
  classes: PropTypes.instanceOf(Object),
  login: PropTypes.instanceOf(Object),
  userProgramsFull: PropTypes.instanceOf(Object),
  handleSearch: PropTypes.func,
  handleOpenDeleteUserPopup: PropTypes.func,
  toggleAddUserPopup: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/Components/Toolbar.jsx